import React from "react";

const TypographyTable = ({ styles }) => {
  function renderedTypographyPreview() {
    if (styles) {
      return (
        <table className="typography-table">
          <thead>
            <tr>
              <td>Font</td>
              <td>Font Weight</td>
              <td>Font Style</td>
              <td>Text Preview</td>
            </tr>
          </thead>
          <tbody>
            {styles.kit.families.map((item) => {
              return item.variations.map((variation) => {
                const fontWeight = variation.substring(1, 2) * 100;
                const fontStyle = variation.substring(0, 1) === "n" ? "Normal" : "Italic";

                return (
                  <tr key={`${item.name}-${fontWeight}-${fontStyle}`}>
                    <td style={{ fontFamily: item.css_names[0] }}>{item.name}</td>
                    <td>{fontWeight || 400}</td>
                    <td>{fontStyle || "Normal"}</td>
                    <td>
                      <p
                        style={{
                          fontFamily: item.css_names[0],
                          fontStyle: fontStyle,
                          fontWeight: fontWeight,
                        }}>
                        This is the text preview in paragraph format
                      </p>
                    </td>
                  </tr>
                );
              });
            })}
          </tbody>
        </table>
      );
    }

    return <p>Input Adobe Font ID to see Preview</p>;
  }

  return (
    <div>
      <div className="typography-preview">{renderedTypographyPreview()}</div>
    </div>
  );
};

export default TypographyTable;
